import { Component } from '@angular/core';

@Component({
  selector: 'app-user-manual-and-tutorial',
  standalone: true,
  imports: [],
  templateUrl: './user-manual-and-tutorial.component.html',
  styleUrl: './user-manual-and-tutorial.component.scss'
})
export class UserManualAndTutorialComponent {

}
